export { default } from "./useUserSchoolGet";
